'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { logger } from '#pplx/frontend/logger/browser.js';
import { DEFAULT_LOCALE } from '#pplx_generated/pplx/frontend/i18n/localeInfo.generated.js';
import React, { useCallback } from 'react';
import { IntlProvider } from 'react-intl';
const EMPTY_MESSAGES = {};
export const TranslationsProvider = React.memo(function TranslationsProvider({ locale, children, messages = EMPTY_MESSAGES, }) {
    const onError = useCallback((error) => {
        // We don't want to log missing translations since we already
        // have a functional test for this. This typically only happens in dev mode.
        if (error.code === 'MISSING_TRANSLATION') {
            return;
        }
        logger.error(error);
    }, []);
    return (_jsx(IntlProvider, { locale: locale, defaultLocale: DEFAULT_LOCALE, messages: messages, onError: onError, children: children }));
});
//# sourceMappingURL=provider.js.map